<template>
    <nav class="navbar navbar-marketing navbar-expand-lg bg-transparent navbar-dark fixed-top d-print-none">
        <div class="container">   
            <router-link class="navbar-brand" to="/" onclick="dataLayer.push({'event': 'nav-logo-click-home'});"><img src="../assets/ICN_Logo.png"></router-link>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
                <ul class="navbar-nav ml-auto mr-lg-5">
                <li class="nav-item">
                     <router-link to="/" class="nav-link" onclick="dataLayer.push({'event': 'nav-home-header'});">Home</router-link>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" href="#">Community</a>
                </li> -->
                <li class="nav-item">
                    <router-link to="/resource-list" class="nav-link"  onclick="dataLayer.push({'event': 'nav-resources-header'});">Resources</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/support" class="nav-link"  onclick="dataLayer.push({'event': 'nav-support-header'});">Support</router-link>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" href="#">Testimonials</a>
                </li> -->
                </ul>
            </div>
        </div>
    </nav>
</template>